import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatStringCurrency } from "../common/CurrencyFormatter";
import { PoolXMoney } from "../models/money";
import { getCashoutThemeColors, themeC } from "../theme/themehelper";

interface CashoutButtonProps {
    value: PoolXMoney;
    disabled?: boolean;
    onClick: () => void;
    fontFamily?: string;
}

const CashoutButton: React.FC<CashoutButtonProps> = ({ value, disabled = false, onClick, fontFamily }) => {
    const { t } = useTranslation();
    const theme = (window as any).theme;
    const { cashOutBg, cashOutText } = getCashoutThemeColors(theme);
    const isTall = theme === themeC.Orange || theme === themeC.Lion;
    const isCompactLabel = theme === themeC.Green || theme === themeC.Kryss || theme === themeC.Lyllo
        || theme === themeC.Dbet || theme === themeC.Stugan || theme === themeC.Snabbare;

    const label = (
        <>
            {t('cash_out')} {formatStringCurrency(value.amount, value.currency, t, false, true)}
        </>
    );

    if (isTall) {
        return (
            <Box
                onClick={disabled ? undefined : onClick}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '12px 24px',
                    gap: '8px',
                    height: '48px',
                    background: cashOutBg,
                    borderRadius: '6px',
                    boxSizing: 'border-box',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.5 : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                }}
            >
                <Typography sx={{ fontFamily, fontWeight: 400, fontSize: '18px', lineHeight: '24px', color: cashOutText }}>
                    {label}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            onClick={disabled ? undefined : onClick}
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px 24px',
                gap: '8px',
                height: '36px',
                background: cashOutBg,
                borderRadius: isCompactLabel ? '4px' : '6px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
            }}
        >
            <Typography sx={{ fontFamily, fontWeight: isCompactLabel ? 700 : 400, fontSize: isCompactLabel ? '14px' : '18px', lineHeight: '24px', color: cashOutText, textTransform: isCompactLabel ? 'uppercase' : undefined }}>
                {label}
            </Typography>
        </Box>
    );
};

export default CashoutButton;
